<template>
    <div class="account-detail">
        <div class="box_header">
            <DataCenterHeader :initId="initId" :isChangeAccount="isChangeAccount" @selectAccountData="getAccountInfo">
                <!-- <el-button slot="header-right" size="mini" @click="handlePublish">发布作品</el-button> -->
            </DataCenterHeader>
        </div>

        <div class="content-box">
            <div class="menus">
                <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                    <el-menu-item v-for="item in menuConfig" :key="item.index" :index="item.index">{{ item.name }}</el-menu-item>
                </el-menu>
            </div>

            <component ref="componentRef" :is="getComponents" :account="accountInfo" :is-header="false" :isDetail="false"></component>
        </div>
    </div>
</template>

<script>
import DataCenterHeader from "@/components/dataCenter/DataCenterHeader.vue";
import ShortVideo from "@/components/dataCenter/ShortVideo.vue";
import LiveStreaming from "@/components/dataCenter/LiveStreaming.vue";
import VideoManagementNew from "@/views/student/creativecenter/VideoManagementNew.vue";
import FanPortrait from "@/views/student/creativecenter/dataCenter/FanPortrait.vue";

export default {
    name: "AccountDetail",
    data() {
        return {
            accountInfo: {},
            activeIndex: "1",
            menuConfig: [
                {
                    index: "1",
                    name: "短视频",
                    component: "ShortVideo",
                },
                {
                    index: "2",
                    name: "直播",
                    component: "LiveStreaming",
                },
                {
                    index: "3",
                    name: "粉丝画像",
                    component: "FanPortrait",
                },
                {
                    index: "4",
                    name: "作品管理",
                    component: "VideoManagementNew",
                },
            ],
        };
    },

    props: {
        initId: {
            type: Number,
        },

        isChangeAccount: {
            type: Boolean,
            default: true,
        },
    },

    computed: {
        getComponents() {
            const component = this.menuConfig.find((item) => item.index == this.activeIndex);
            return component.component;
        },
    },

    components: {
        DataCenterHeader,
        ShortVideo,
        LiveStreaming,
        VideoManagementNew,
        FanPortrait,
    },

    methods: {
        getInitData() {
            if (this.activeIndex === "1") {
            } else if (this.activeIndex === 2) {
            } else if (this.activeIndex === "3") {
                this.$refs.componentRef?.getFans(this.accountInfo);
            } else if (this.activeIndex === "4") {
                this.$refs.componentRef?.getAccountInfo(this.accountInfo);
            }
        },

        getAccountInfo(accountInfo) {
            this.accountInfo = accountInfo;

            this.getInitData();
        },

        handleSelect(key, keyPath) {
            this.activeIndex = key;

            this.$nextTick(() => {
                this.getInitData();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.account-detail {
    height: 100%;
    // background-color: red;
    display: flex;
    flex-direction: column;
    gap: 20px;

    .content-box {
        flex: 1;
        min-height: 0;
        padding: 0 24px 24px 24px;
        border-radius: 8px;
        box-sizing: border-box;
        background-color: #fff;

        ::v-deep .el-menu--horizontal > .el-menu-item.is-active {
            border-color: #594fee;
        }
    }

    ::v-deep .content-box,
    ::v-deep .content_box {
        margin-top: 0 !important;
    }
}
</style>
